/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Contact\ContactSelect\ContactSelect.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Friday July 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday July 7th 2023 1:58:19 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { SelectProps } from "Content/Contact/ContactSelect/SelectPropsInterface";
import translator from "MultiLanguage/TranslationWrapper";
import { ActionMeta, SingleValue } from "react-select";
import { OptionType } from "Content/Contact/ContactSelect/OptionTypeInterface";
import Select from "Theme/Component/Select";

export function ContactSelect(props: SelectProps) {
  return (
    <Select styles={{
        control: (provided: any[], state: any) => ({
          ...provided,
          boxShadow: "none",
          borderRadius: 0,
          border: "none",
          // borderBottom: "solid 1px grey !important"
        }),
        menu: (provided: any[], state: any) => ({
          ...provided,
          border: "solid grey 1px",
          zIndex: "100 !important",
          backgroundColor: "white",
        }),
        option: (provided: any[], state: any) => ({
            ...provided,
            backgroundColor: state.isFocused && "grey",
            color: state.isFocused && "white",
        })
      }}
      className={props.className}
      disabled={props.disabled}
      id={props.id}
      value={props.value}
      options={props.options && Array.isArray(props.options) && (props.options as any[]).every((it: string | OptionType) => typeof it === 'string') ? (props.options as any[]).map((v: string) => { return {label: props.contactSubCategory != undefined ? translator.decode(`${props.contactSubCategory}.${v}`) as string : v, value: v}}) : (props.options ? props.options as OptionType[]: [])}
      onChange={(e: SingleValue<OptionType>, action: ActionMeta<SingleValue<OptionType>>) => { props.onChange(e != null ? e : props.value) }}
      isSearchable={props.searchable}
    />
  );
}
